<template>
  <div>
    <el-dialog
      v-if="visible"
      show-close
      :visible.sync="visible"
      width="800px"
      :title="$l('dialog_title_moveDoc') || '移动文档目录'"
      :close-on-click-modal="false"
      :before-close="() => close()"
      append-to-body
      v-el-dialog-drag
    >
      <Main
        ref="main"
        :custCode="custCode"
        :custDocCode="custDocCode"
        :custFolderCode="custFolderCode"
        @close="close"
        @reload="$emit('reload')"
      />
      <span slot="footer">
        <el-button size="small" @click="close()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="$refs.main.confirm()">
          {{ $l('INDEX.btn_confirm') || '确认' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    custCode: { type: String, default: '' },
    custDocCode: { type: String, default: '' },
    custFolderCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
